module.exports = __webpack_public_path__ + "static/media/554JamesPBrawleyDrNW_2018-06-12_100.eafd1320.jpg";